import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import WeekSwitch from '../../Common/weekSwitch';
import ActivityTable from './ActivityTable';
import { semanticColors } from '../../Globals/styles'
import SmartSpinner from '../../Common/SmartSpinner'
import Waves from 'node-waves'
import Radium from 'radium';

class WeekOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currDate: new Date()
    }
  }
  /*changeDate gets fired somewhat after componentDidMount
  because of the Weekswitch callback in render()*/
  changeDate = (newDate) => {
    this.setState({ currDate: newDate });
    this.props.dispatch(actions.fetchWeekly(this.props.params.projectNumber,
      this.state.currDate))
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  getButtonContent = () => {
    const { isFormSaved, isSubmitting } = this.props.weeklyOverview;
    var content = 'Gem';
    if (isSubmitting) {
      content = (<i className="fa fa-spinner fa-spin fa-2x"></i>)
    }
    else if (isFormSaved) {
      content = (<i className="fa fa-check"></i>)
    }
    return content;
  };
  confirmDelete = (rootIndex, index, id, thirdIndex, sub) => {
    const { dispatch } = this.props;
    if (window.confirm('Er du sikkker på du vil slette?')) {
      dispatch(actions.deleteActivity(rootIndex, index, id, thirdIndex, sub))
    }
  };
  render() {
    const { dispatch, weeklyOverview } = this.props;
    return (
      <div style={styles.view}>
        <div className="container-fluid" style={styles.container}>
          <div className="row" style={styles.headingRow}>
            <div className="col-xs-12 text-center" style={styles.header}>
              <div className="col-xs-1" style={styles.Projektoversigt}>Projektoversigt</div>
              <div className="col-xs-9">
                <WeekSwitch onChange={this.changeDate} initialDate={this.state.currDate} />
              </div>
              {/*LOADER*/}
              <div className="col-xs-1" style={styles.SaveButtonExcel} onClick={() => dispatch(actions.exportToExcel())}>
                <i className="fa fa-file-excel-o" style={{ paddingRight: '5px' }} aria-hidden="true"></i>
                Eksportér
              </div>
              <div className="col-xs-1" style={styles.loaderContainer}>
                <SmartSpinner />
              </div>
            </div>
          </div>
          <div className="row" style={styles.content}>
            <ActivityTable
              {...weeklyOverview}
              currDate={this.state.currDate}
              projectNumber={this.props.params.projectNumber}
              deleteActivity={(rootIndex, index, id, thirdIndex, sub) => this.confirmDelete(rootIndex, index, id, thirdIndex, sub)}
              updatePercent={(id, percent, oldPercent) => dispatch(actions.submitPercent(this.state.currDate, id, percent, oldPercent))}
            />
          </div>
        </div>
      </div>
    );
  }
}

var styles = {
  view: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0',
    paddingTop: '100px',
    animation: 'slideInRight 0.3s'
  },
  container: {
    height: '100%',
    position: 'relative'
  },
  Projektoversigt: {
    fontSize: '16px',
    fontWeight: '600',
    verticalAlign: 'middle',
    height: '30px',
    lineHeight: '30px',
    padding: '0px'
  },
  SaveButtonExcel: {
    verticalAlign: 'middle',
    height: '30px',
    lineHeight: '30px',
    padding: '0px',
    cursor: 'pointer',
  },
  headingRow: {
    position: 'absolute',
    top: '-75px',
    width: '100%'
  },
  header: {
    marginTop: '37px',
    '@media (min-width: 1200px)': {
      padding: '0px',
      maxWidth: '1170px',
      left: '50%',
      marginLeft: '-585px'
    }
  },
  content: {
    backgroundColor: semanticColors.default,
    height: '100%'
  },
  loaderContainer: {
    textAlign: 'right',
    padding: '0'
  }
}

const selectProps = state => {
  return {
    weeklyOverview: { ...state.weeklyOverviewReducer }
  };
}

export default connect(selectProps)(Radium(WeekOverview));



// WEBPACK FOOTER //
// ./src/App/Project/WeekOverview/index.jsx